"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.titleCase = exports.formatDateFields = exports.formatBooleanAsYesNo = exports.dateUk = exports.dateTimeUk = void 0;
var dateTimeUk = function dateTimeUk(value) {
  if (!value) {
    return '';
  }
  var splitDateString = value.split('T');
  var splitTimePortion = splitDateString.length > 1 ? splitDateString[1].split(':') : [];
  return [splitDateString[0].split('-').reverse().join('/'), splitTimePortion.length > 0 ? splitTimePortion[0] + ":" + splitTimePortion[1] : ''].join(' ');
};
exports.dateTimeUk = dateTimeUk;
var dateUk = function dateUk(value) {
  return value ? value.split('T')[0].split('-').reverse().join('/') : value;
};
exports.dateUk = dateUk;
var titleCase = function titleCase(stringValue) {
  return stringValue.replace(/(\w)(\w*)/g, function (g0, g1, g2) {
    return g1.toUpperCase() + g2.toLowerCase();
  });
};
exports.titleCase = titleCase;
var formatDateFields = function formatDateFields(dataArray, dateFieldsArray) {
  return dataArray && dateFieldsArray ? dataArray.map(function (item) {
    var copiedItem = Object.assign({}, item);
    dateFieldsArray.forEach(function (fieldName) {
      copiedItem[fieldName] = dateTimeUk(item[fieldName]);
    });
    return copiedItem;
  }) : dataArray;
};
exports.formatDateFields = formatDateFields;
var formatBooleanAsYesNo = function formatBooleanAsYesNo(dataArray, booleanFieldsArray) {
  return dataArray.map(function (item) {
    var copiedItem = Object.assign({}, item);
    booleanFieldsArray.forEach(function (fieldName) {
      if (typeof item[fieldName] === "boolean") {
        copiedItem[fieldName] = item[fieldName] === true ? "Yes" : "No";
      }
    });
    return copiedItem;
  });
};
exports.formatBooleanAsYesNo = formatBooleanAsYesNo;